module.exports = __webpack_public_path__ + "static/media/onboard-3-card-detail.aaf36d60.gif";